import React, { Fragment } from "react";
import NbfcUploadedAuctionList from "../../containers/autionDataList/nbfcUploadedAuctionList";
import Header from "../../components/header";

const UploadedAuctionListPage = () => {

	return (
		<Fragment>
			<Header>
				<Header.MaxWidth>
					<Header.Logo
						src="../assets/title/Tractor world Logo.svg"
						alt="Logo"
					/>
				</Header.MaxWidth>
			</Header>
            <NbfcUploadedAuctionList />
		</Fragment>
	);
};

export default UploadedAuctionListPage;
